interface IFormatUrl {
  urlBase: string;
  path: string;
  restUrlParams?: IUrlParams[];
  queryUrlParams?: IUrlParams[];
}

export interface IUrlParams {
  name: string;
  value: string;
}

export const formatUrl = ({ urlBase, path, restUrlParams, queryUrlParams }: IFormatUrl): string => {
  let url = formatBaseUrl(urlBase, path);

  if (restUrlParams?.length) {
    url = replaceRestUrlParams(url, restUrlParams);
  }

  if (queryUrlParams?.length) {
    url = formatQueryString(url, queryUrlParams);
  }

  return url;
};

const formatBaseUrl = (urlBase: string, path: string): string =>
  `${urlBase}${urlBase.endsWith('/') ? '' : '/'}${removeSlashFromUrlPath(path)}`;

const replaceRestUrlParams = (url: string, restUrlParams: IUrlParams[]): string =>
  restUrlParams.reduce((prevValue, { name, value }) => prevValue.replace(`{${name}}`, value), url);

const formatQueryString = (url: string, queryStringParams: IUrlParams[]): string =>
  queryStringParams.reduce((prevValue: string, { name, value }, index) => {
    if (index) {
      return `${prevValue}&${formatQueryParam(name, value)}`;
    }

    return `${prevValue}${formatQueryParam(name, value)}`;
  }, `${url}?`);

const formatQueryParam = (name: string, value: string): string => `${name}=${value}`;

const removeSlashFromUrlPath = (path: string) => (path.startsWith('/') ? path.slice(1) : path);
